// Type Imports
import useUserRole from '@/hooks/useUserRole';
import type { VerticalMenuDataType } from '@/types/menu.type';

// Handle permissions
const VerticalMenuData = (): VerticalMenuDataType[] => {
    const { roleType } = useUserRole();

    if (!roleType) {
        return [];
    }

    return roleType?.getSidebar() ?? [];
};

export default VerticalMenuData;
